function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.welcome-st0{fill:#0853A0;}\n\t.welcome-st1{fill:#0052A5;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st0",
  d: "M24.7,102.9c-0.8,0-1.5-0.7-1.5-1.5l0-93c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5l0,93 C26.2,102.3,25.6,102.9,24.7,102.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st0",
  d: "M14.9,92.2H3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h11.8c0.8,0,1.5,0.7,1.5,1.5S15.7,92.2,14.9,92.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st0",
  d: "M14.9,20.7H3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h11.8c0.8,0,1.5,0.7,1.5,1.5S15.7,20.7,14.9,20.7z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st0",
  d: "M14.9,35H3c-0.8,0-1.5-0.7-1.5-1.5S2.2,32,3,32h11.8c0.8,0,1.5,0.7,1.5,1.5S15.7,35,14.9,35z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st0",
  d: "M14.9,49.3H3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h11.8c0.8,0,1.5,0.7,1.5,1.5S15.7,49.3,14.9,49.3z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st0",
  d: "M14.9,63.6H3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h11.8c0.8,0,1.5,0.7,1.5,1.5S15.7,63.6,14.9,63.6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st0",
  d: "M14.9,77.9H3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h11.8c0.8,0,1.5,0.7,1.5,1.5S15.7,77.9,14.9,77.9z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st0",
  d: "M48.7,91.7c-0.4,0-0.8-0.2-1.1-0.5c-0.4-0.4-0.5-1-0.3-1.5l4.8-13.2c0.1-0.2,0.2-0.4,0.3-0.5l45.2-45.2 c0.6-0.6,1.5-0.6,2.1,0l9,9c0.6,0.6,0.6,1.5,0,2.1L63.6,87.1c-0.2,0.2-0.4,0.3-0.6,0.4l-13.9,4.2C49,91.7,48.8,91.7,48.7,91.7z  M54.8,77.8l-3.7,10.1l10.6-3.2l43.8-43.8l-6.9-6.9L54.8,77.8z M62.5,86L62.5,86L62.5,86z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st0",
  d: "M62.8,86c-0.4,0-0.8-0.1-1.1-0.4l-8-8c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l8,8c0.6,0.6,0.6,1.5,0,2.1 C63.6,85.9,63.2,86,62.8,86z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st0",
  d: "M102.7,46.1c-0.4,0-0.8-0.1-1.1-0.4l-8-8c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l8,8 c0.6,0.6,0.6,1.5,0,2.1C103.5,46,103.1,46.1,102.7,46.1z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "welcome-st1",
  d: "M84.1,103.8H16.6c-4.5,0-8.1-3.7-8.1-8.1V14.5c0-4.5,3.7-8.1,8.1-8.1h67.5c4.5,0,8.1,3.7,8.1,8.1v15.3 c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5V14.5c0-2.8-2.3-5.1-5.1-5.1H16.6c-2.8,0-5.1,2.3-5.1,5.1v81.1c0,2.8,2.3,5.1,5.1,5.1h67.5 c2.8,0,5.1-2.3,5.1-5.1V68.4c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v27.3C92.2,100.2,88.6,103.8,84.1,103.8z"
});

var SvgWelcomeScreen = function SvgWelcomeScreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dzienik-fill",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWelcomeScreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/welcome-screen.607bd164.svg";
export { ForwardRef as ReactComponent };